import { add } from 'date-fns';
import { createSelector } from 'reselect';

export const getVisibilityByView = (cfg) => {
    const { forceDFV, masterFlagDisabled, viewFlag, isValidGame } = cfg;
    const enabled = !(masterFlagDisabled || (!masterFlagDisabled && viewFlag));
    return forceDFV || (enabled && isValidGame);
};

// selectors
const getPlayTimeStamp = (state) => state?.dynamicFieldView?.playTimeStamp;
const getDFVConfig = (state) => state.config;
const getGameStatus = (state) => state.gumbo?.gameData?.status;
const getGamedayType = (state) => state.gumbo?.gameData?.game?.gamedayType;
const getVenue = (state) => state.gumbo?.gameData?.venue;
const getLiveData = (state) => state.gumbo?.liveData;
const getCurrentPlay = (state) => getLiveData(state)?.plays?.currentPlay;
const getVenueId = (state) => getVenue(state)?.id;
const getVenueName = (state) => getVenue(state)?.name;
const getGamePk = (state) => state?.dynamicFieldView?.gamePk;

export const getEnableDFVDesktop = (state) => {
    const { disableDynamicFieldView, disableDynamicFieldViewDesktop, forceDFV } = getDFVConfig(state);
    const isValidGame = getIsValidGame(state);
    return getVisibilityByView({ forceDFV, masterFlagDisabled: disableDynamicFieldView, viewFlag: disableDynamicFieldViewDesktop, isValidGame });
};

export const getEnableDFVMobile = (state) => {
    const { disableDynamicFieldView, disableDynamicFieldViewMobile, forceDFV } = getDFVConfig(state);
    const isValidGame = getIsValidGame(state);
    return getVisibilityByView({ forceDFV, masterFlagDisabled: disableDynamicFieldView, viewFlag: disableDynamicFieldViewMobile, isValidGame });
};

const getInWarmupWindow = (state) => {
    const gameStatus = getGameStatus(state);
    const { statusCode } = gameStatus;
    const isWarmup = statusCode === 'PW';
    const currentPlay = getCurrentPlay(state);
    let inWarmupWindow;

    if (isWarmup) {
        const warmupStart = new Date(currentPlay?.about?.endTime).toISOString();
        const twoPostWarmup = add(new Date(warmupStart), { minutes: 2 }).toISOString();
        const now = new Date().toISOString();
        inWarmupWindow = now < twoPostWarmup;
    } else {
        inWarmupWindow = false;
    }

    return inWarmupWindow;
};

export const getIsValidGame = (state) => {
    const venueId = getVenueId(state);
    const gamedayType = getGamedayType(state);
    const gameStatus = getGameStatus(state);
    const { fieldViewVenues } = getDFVConfig(state);
    const validVenueId = fieldViewVenues?.has(venueId?.toString());
    const { codedGameState, statusCode, abstractGameCode } = gameStatus;

    const isSuspended = codedGameState === 'T' || codedGameState === 'U';
    const isGameDelay = codedGameState === 'I' && (statusCode !== 'I' && statusCode !== 'IH');
    const validGameState = abstractGameCode === 'L' && !isSuspended && !isGameDelay;
    const validGamedayType = gamedayType === 'P' || gamedayType === 'E';

    return validGamedayType && validGameState && validVenueId;
};

const getDFVAhead = (state) => getDFVConfig(state).DFVSyncThresholdAhead;
const getDFVBehind = (state) => getDFVConfig(state).DFVSyncThresholdBehind;

export const getTimeSyncInfo = createSelector(
    [getPlayTimeStamp, getDFVBehind, getDFVAhead],
    (playTimeStamp, behind, ahead) => {
        return {
            playTimeStamp,
            syncingThresholds: {
                ahead,
                behind
            }
        };
    });

// reselect function
export const getDynamicFieldView = createSelector(
    [getVenueId, getVenueName, getEnableDFVDesktop, getEnableDFVMobile, getInWarmupWindow, getGamePk],
    (venueId, venueName, enableDFVDesktop, enableDFVMobile, inWarmupWindow, gamePk) => {
        const venueIdString = venueId?.toString();
        return {
            venueId: venueIdString,
            venueName,
            enableDFVDesktop,
            enableDFVMobile,
            inWarmupWindow,
            gamePk
        };
    }
);
